// extracted by mini-css-extract-plugin
export default {"content":"Mention-module__content--XGMk1","container":"Mention-module__container--R4jbP","animatedBackground":"Mention-module__animatedBackground--E-TLw"};